//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import MainBanners from './_components/MainBanners';
import Feedback from './_components/Feedback';
import CourseList from './_components/CourseList';
import TeacherList from './_components/TeacherList';
import TeacherRegisterDialog from './_components/TeacherRegisterDialog';
import TeacherWelcomeDialog from './_components/TeacherWelcomeDialog';

export default {
  name: 'Training',
  components: {
    MainBanners,
    Feedback,
    TeacherList,
    CourseList,
    TeacherRegisterDialog,
    TeacherWelcomeDialog,
  },
  data() {
    return {
      isTeacherRegisterDialogShow: false,
      isTeacherWelcomeDialogShow: false,
    };
  },
  head() {
    return {
      title: 'STEP1NE 企訓之王 - 專業教育訓練與開課平台',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '提升專業能力 - STEP1NE企業培訓',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'STEP1NE提供專業的企業培訓服務，與多位優質講師及教育訓練機構合作，覆蓋全台各地，致力於提升企業及個人的專業能力。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'STEP1NE提供專業的企業培訓服務，與多位優質講師及教育訓練機構合作，覆蓋全台各地，致力於提升企業及個人的專業能力。',
        },
      ],
    };
  },
  methods: {
    ...mapActions('lecturer', ['getTeachingFields']),
    openRegister() {
      this.isTeacherRegisterDialogShow = true;
    },
    openWelcome() {
      this.isTeacherWelcomeDialogShow = true;
    },
  },
  created() {
    // this.getTeachingFields();
    if (!process.env.isLecturerOpen) this.$router.push('/');
  },
};
